import { errorDetail, errorMessage } from '../lib/api-error';

interface Props {
  /** Whatever was caught. Strings are fine too (local validation messages). */
  error: unknown;
  /** Prefix such as "Debt error" — rendered as "Debt error: <copy>". */
  label?: string;
  className?: string;
}

/**
 * Renders a caught error as short human copy, with the raw server body tucked
 * behind a collapsed "Details" instead of dumped into the page. See lib/api-error.
 */
export function ErrorBanner({ error, label, className }: Props) {
  if (error === null || error === undefined || error === '') return null;
  const detail = errorDetail(error);
  return (
    <div className={className ?? 'py-1 text-[11px] text-red-600'}>
      {label ? `${label}: ` : ''}
      {errorMessage(error)}
      {detail && (
        <details className="mt-0.5">
          <summary className="cursor-pointer text-[10px] text-red-400 hover:text-red-600">Details</summary>
          <pre className="mt-0.5 max-h-32 overflow-auto whitespace-pre-wrap break-all text-[10px] text-gray-500">
            {detail}
          </pre>
        </details>
      )}
    </div>
  );
}
